<script setup>
import {useStore} from "vuex";
import {computed} from "vue";
import ExportBacklinksButton from "@/components/competition/partials/backlinks/ExportBacklinksButton.vue";
import SelectInput from "@/components/global-themed/inputs/SelectInput.vue";
import {debounce} from "lodash/function";

const store = useStore();

const search = computed(() => store.getters['competitionV2/backlinksSearch']);

const view = computed(() => store.getters['competitionV2/backlinksView']);

const onSearchInput = debounce((e) => {
  store.dispatch('competitionV2/setBacklinksSearch', e.target.value);
}, 500);

</script>

<template>
  <div class="tw-grid tw-grid-cols-12 tw-gap-4 tw-items-center">
    <div class="tw-col-span-6">
      <label class="tw-border-2 tw-border-grey-mid tw-rounded-md tw-flex tw-text-black tw-col-span-12">
        <svg-vue
          icon="icons/search"
          class="tw-w-7 tw-h-7 tw-my-2 tw-ml-3 tw-text-grey"
        />
        <input
          :value="search"
          placeholder="Search"
          class="tw-border-0 tw-w-full tw-pl-3 tw-text-lg tw-pr-2"
          type="search"
          @input="onSearchInput"
        >
      </label>
    </div>
    
    <div class="tw-col-span-3">
      <SelectInput
        @input="(e) => store.dispatch('competitionV2/setBacklinksView', e.target.value)"
      >
        <option
          value="simple"
          :selected="view === 'simple'"
        >
          Simple View
        </option>
        <option
          value="advanced"
          :selected="view === 'advanced'"
        >
          Advanced View
        </option>
      </SelectInput>
    </div>

    <div class="tw-col-span-3 tw-flex tw-justify-end">
      <ExportBacklinksButton />
    </div>
  </div>
</template>
